import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';

// One logical qdrant document: chunks grouped by external_id, carrying
// citation provenance when the citation pipeline captured it.
export interface CollectionDocument {
  external_id: string | null;
  chunk_count: number;
  text_preview: string;
  payload: {
    title?: string;
    url?: string;
    source_type?: string;
    /** Usually an array, but some ingest paths store a comma-joined string. */
    labels?: string[] | string;
    workflow_id?: string;
    session_id?: string;
    run_id?: string;
    node_id?: string;
    citation_id?: string;
    query?: string;
    note?: string;
    captured_at?: string;
    datetime?: string;
    index_time?: string;
    original_filename?: string;
    tags?: string[];
    [key: string]: unknown;
  };
}

export interface CollectionDocumentsResponse {
  status: string;
  collection_id: string;
  documents: CollectionDocument[];
  chunk_count_scanned: number;
  next_offset: string | number | null;
}

export const getCollectionDocuments = async (
  collectionId: string,
  options: { limit?: number; offset?: string | number | null } = {},
): Promise<CollectionDocumentsResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const params = new URLSearchParams();
  params.set('limit', String(options.limit ?? 200));
  if (options.offset != null) {
    params.set('offset', String(options.offset));
  }

  const response = await apiRequest<CollectionDocumentsResponse>({
    url: `/collections/${orgId}/${collectionId}/documents?${params.toString()}`,
    method: 'GET',
    target: 'platform',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }
  if (!response.data) {
    throw new Error('Unexpected response format');
  }
  return response.data;
};
